module.exports = __webpack_public_path__ + "static/media/divya.a2940f8b.jpg";